import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function LongevityFitnessCta() {
  return <section id="longevityfitnesscta" data-nav="light" className="bg-background text-foreground py-16 sm:py-20 lg:py-24">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="relative overflow-hidden rounded-2xl border border-border bg-card p-8 text-card-foreground shadow-xs sm:p-12 lg:p-16">
          <div className="relative z-10 mx-auto max-w-3xl text-center">
            <h2 className="text-2xl font-bold tracking-tight text-foreground sm:text-3xl lg:text-4xl">
              Longevity & Fitness Testing with PhysAnalytica
            </h2>
            <p className="mt-4 text-base leading-relaxed text-muted-foreground sm:text-lg">
              Longevity and fitness assessments are available through selected PhysAnalytica locations. Availability depends on the assessments required, equipment, and practitioner availability.
            </p>
            <div className="mt-8 flex justify-center">
              <Button asChild size="lg" className="gap-2">
                <Link to="/ContactPage">
                  <span>Ask About Availability</span>
                  <ArrowRight className="size-4" />
                </Link>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>;
}